module.exports = __webpack_public_path__ + "media/javascripts/apps/roku/assets/images/TVslide-1-4b54aa8b52b13deb86320c87a2d5d4fc.png";